import React from 'react';
import { SideBar } from './sidebar';
import {
  getAllAuctionsByGroup,
  getEnrolledUsers,
  activateUserEnroll,
  deActivateUserEnroll,
  activateAllUserEnroll,
  deleteEnrolledUser,
  approveOrRejectEnrolls,
  enrollBulkDelete,
  getEnrolledUsersByGroup,
} from '../../models/auctions';
import DataTable from 'react-data-table-component';
import i18n from '../../i18n';
import swal from 'sweetalert';
import { getAllGroups, getGroup } from '../../models/groups';
import { apiUrl } from '../../constants/global';
import { getLoggedUser } from '../../state/user';
import { getAllOrganization } from '../../models/organization';
import { ListTable } from '../helpers/skeletons/ListTable';
import Select from 'react-select';
import HeaderBanner from '../common/HeaderBanner';

const customStyles = {
  headCells: {
    style: {
      fontWeight: 'bold',
      backgroundColor: '#e4f7ff',
      color: '#000000',
    },
  },
};

const selectStyles = {
  control: (provided) => ({
    ...provided,
  }),
  option: (provided) => ({
    ...provided,
    zIndex: 2,
  }),
  singleValue: (provided) => ({
    ...provided,
  }),
  menuPortal: (provided) => ({ ...provided, zIndex: 9 }),
};

const user = getLoggedUser();
export class EnrolledUsersManage extends React.Component {
  constructor() {
    super();
    let urlSearchParams = new URLSearchParams(window.location.search);
    let params = Object.fromEntries(urlSearchParams.entries());
    this.state = {
      bulk_updating: false,
      row_updating: false,
      totalRows: 0,
      currentPage: 1,
      input: {
        page: 1,
        limit: 15,
        type: 'active',
        group: params.group ? params.group : '',
        id: params.id ? params.id : '',
        nid: params.nid ? params.nid : '',
        uid: params.uid ? params.uid : '',
      },
      query: '',
      auctions: [],
      is_loading: false,
      customers: [],
      clients: [],
      groups: [],
      group_auctions: [],
      isChecked: false,
      isAllChecked: false,
      selected_ids: [],
      columns: [
        {
          name: 'ID',
          sortable: true,
          width: '100px',
          cell: (row) => row?.id ?? '',
        },
        {
          name: i18n.t('group'),
          sortable: true,
          cell: (row) => row?.group?.group_name ?? '',
        },
        {
          name: i18n.t('name'),
          sortable: true,
          cell: (row) => row?.user?.name ?? '',
        },
        {
          name: i18n.t('username'),
          sortable: true,
          cell: (row) => row?.user?.username ?? '',
        },
        {
          name: i18n.t('email'),
          cell: (row) => row?.user?.email ?? '',
        },
        {
          name: i18n.t('mobile'),
          wrap: true,
          cell: (row) => row?.user?.mobile ?? '',
        },
        {
          name: i18n.t('auction'),
          wrap: true,
          cell: (row) => row?.auction?.title ?? '',
        },
        {
          name: i18n.t('identity_type'),
          wrap: true,
          cell: (row) => row?.identity_type ?? '',
        },
        {
          name: i18n.t('Civil Card'),
          cell: (row) =>
            row?.file_civil_card ? (
              <a href={row.file_civil_card} target="_blank" rel="noreferrer">
                Download
              </a>
            ) : (
              ''
            ),
        },
        {
          name: i18n.t('Signature'),
          cell: (row) =>
            row?.file_signature ? (
              <a href={row.file_signature} target="_blank" rel="noreferrer">
                Download
              </a>
            ) : (
              ''
            ),
        },
        {
          name: i18n.t('receipt'),
          cell: (row) =>
            row?.file_receipt ? (
              <a href={row.file_receipt} target="_blank" rel="noreferrer">
                Download
              </a>
            ) : (
              ''
            ),
        },
        {
          name: i18n.t('account_number'),
          wrap: true,
          cell: (row) => row?.account_number || 'No',
        },
        {
          name: i18n.t('is_company'),
          wrap: true,
          cell: (row) => (row?.is_company === 1 ? 'Yes' : 'No'),
        },
        {
          name: i18n.t('cr_number'),
          wrap: true,
          cell: (row) => (row?.is_company === 1 ? row?.cr_number : 'No'),
        },
        {
          name: i18n.t('Bank Account'),
          cell: (row) =>
            row?.file_ba ? (
              <a href={row.file_ba} target="_blank" rel="noreferrer">
                Download
              </a>
            ) : (
              ''
            ),
        },
        {
          name: i18n.t('Bank Guarantee'),
          cell: (row) =>
            row?.file_bg ? (
              <a href={row.file_bg} target="_blank" rel="noreferrer">
                Download
              </a>
            ) : (
              ''
            ),
        },
        {
          name: i18n.t('CR Certificate'),
          cell: (row) =>
            row?.file_cr ? (
              <a href={row.file_cr} target="_blank" rel="noreferrer">
                Download
              </a>
            ) : (
              ''
            ),
        },
        {
          name: i18n.t('payment type'),
          wrap: true,
          cell: (row) => row?.pay_type ?? '',
        },
        {
          name: i18n.t('payment status'),
          wrap: true,
          cell: (row) =>
            row?.payment != null && row.payment.status === 'P' ? (
              <span className="text-success">Paid</span>
            ) : (
              <span className="text-danger"></span>
            ),
        },
        {
          name: i18n.t('status'),
          cell: (row) =>
            row?.status === 'A' ? (
              <span className="text-success">Approved</span>
            ) : (
              <span className="text-danger">Pending</span>
            ),
        },
      ],
    };
    this.loadAllGroups = this.loadAllGroups.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.activateAllUserEnroll = this.activateAllUserEnroll.bind(this);
    this.activate = this.activate.bind(this);
    this.deActivate = this.deActivate.bind(this);
    this.deleteEnroll = this.deleteEnroll.bind(this);
  }

  componentDidMount() {
    let input = this.state.input;
    let qstring = new URLSearchParams(input).toString();
    this.setState({ query: qstring });
    this.loadAllOrganisation();
    this.loadAllGroups();
    this.loadAllEnrolledUsers(qstring);
    this.loadCustomers();
  }

  async loadAllGroups() {
    let q = '';
    let { input } = this.state;
    if (input.client) {
      q += `organization=${input.client}`;
    }
    if (input.group) {
      q += `&group=${input.group}`;
    }
    const response = await getAllGroups(q);
    let groups = response?.data ?? [];
    this.setState({ groups });
    if (input.group && groups.length > 0) {
      this.setState({ input });
      this.loadAuctionsByGrp();
    }
  }

  async loadAuctionsByGrp() {
    let { input } = this.state;
    const response = await getAllAuctionsByGroup(input.group);
    let group_auctions = response?.data ?? [];
    this.setState({ group_auctions });
    if (input.auction_id && group_auctions.length) {
      input.auction = input.auction_id;
      this.setState({ input });
    }
  }

  async loadAllEnrolledUsers(q) {
    this.setState({ is_loading: true });
    if (this.state.input.group) {
      q = q + '&group=' + this.state.input.group;
    }
    if (this.state.input.user_name) {
      q = q + '&uname=' + this.state.input.user_name;
    }
    this.setState({ query: q });
    const response = await getEnrolledUsers(q);
    // Defensive: API can occasionally return null entries inside the array
    // (deleted/orphaned records). Filter those out before they ever reach
    // DataTable, since DataTable's internal cell/selectableRowDisabled
    // logic does not null-check rows itself.
    let rawUsers = Array.isArray(response?.data) ? response.data : [];
    let users = rawUsers
      .filter((item) => item != null)
      .map((item) => ({
        ...item,
        isChecked: false,
      }));
    let meta = response?.meta ?? { total: 0 };
    this.setState({ is_loading: false });
    this.setState({ auctions: users });
    this.setState({ totalRows: meta.total ?? 0 });
  }

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({ input });
    if (event.target.name === 'client') {
      input.group = '';
      this.loadAllGroups();
      this.loadCustomers();
    }
    let query = this.state.query;
    let new_q = this.removeUrlParameter(query, 'group', 'uname');
    this.setState({ query: new_q });
  }

  async loadGroup(id) {
    let response = await getGroup(id);
    let { input } = this.state;
    input.client = '';
    input.group = '';
    input.auction = '';
    if (response?.success) {
      let _data = response.data;
      input.client = _data?.organization ?? '';
      input.group = id;
    }
    this.setState({ input });
    this.loadAllGroups(id);
  }

  removeUrlParameter(url, paramKey1, paramKey2) {
    url = url
      .replace(new RegExp('[?&]' + paramKey1 + '=[^&#]*(#.*)?$'), '$1')
      .replace(new RegExp('([?&])' + paramKey1 + '=[^&]*&'), '$1');
    url = url
      .replace(new RegExp('[?&]' + paramKey2 + '=[^&#]*(#.*)?$'), '$1')
      .replace(new RegExp('([?&])' + paramKey2 + '=[^&]*&'), '$1');
    return url;
  }

  handlePageChange = (page) => {
    window.scrollTo(0, 150);
    let input = this.state.input;
    let currentPage = page;
    input['page'] = currentPage;
    this.setState({ currentPage: currentPage });
    this.setState({ input: input });
    let qstring = new URLSearchParams(input).toString();
    this.setState({ query: qstring });
    this.loadAllEnrolledUsers(qstring);
  };

  async loadAllOrganisation() {
    const response = await getAllOrganization();
    let clients = response?.data ?? [];
    this.setState({ clients });
  }

  async loadCustomers() {
    let q = '';
    if (this.state.input.client) {
      q = q + '&client=' + this.state.input.client;
    }
    if (this.state.input.group) {
      q = q + '&group=' + this.state.input.group;
    }
    if (this.state.input.auction) {
      q = q + '&auction=' + this.state.input.auction;
    }
    const response = await getEnrolledUsersByGroup(q);

    let data = Array.isArray(response?.data) ? response.data : [];
    if (response?.success) {
      const customers = data
        .filter((item) => item != null)
        .map((item) => {
          return {
            value: item.id,
            label: item.name + ' (' + item.username + ')',
          };
        });
      this.setState({ customers: customers });
    }
  }

  activateAllUserEnroll() {
    swal('Are you sure.? Do you want to continue.?', {
      buttons: {
        yes: {
          text: 'Yes',
          value: 'yes',
        },
        no: {
          text: 'No',
          value: 'no',
        },
      },
    }).then((value) => {
      if (value === 'yes') {
        activateAllUserEnroll({
          group: this.state.input.group,
        });
        swal(i18n.t('success'), 'All enrollments activated for this user.', 'success', {
          buttons: false,
          timer: 2000,
        });
        this.loadAllEnrolledUsers(this.state.query);
      }
      return false;
    });
  }

  async activate(id) {
    this.setState({ row_updating: true });
    await activateUserEnroll({ enroll_id: id });
    swal(i18n.t('success'), 'User activated', 'success', {
      buttons: false,
      timer: 2000,
    })
      .then(() => {
        this.setState({ row_updating: false });
        this.loadAllEnrolledUsers(this.state.query);
      })
      .catch(() => {
        swal('Failed', 'Something went wrong', 'error');
      });
  }

  async deActivate(id) {
    this.setState({ row_updating: true });
    await deActivateUserEnroll({ enroll_id: id });
    swal(i18n.t('success'), 'User disabled', 'success', {
      buttons: false,
      timer: 2000,
    })
      .then(() => {
        this.setState({ row_updating: false });
        this.loadAllEnrolledUsers(this.state.query);
      })
      .catch(() => {
        swal('Failed', 'Something went wrong', 'error');
      });
  }

  async deleteEnroll(id) {
    swal('Are you sure.? Do you want to continue.?', {
      buttons: {
        yes: {
          text: 'Yes',
          value: 'yes',
        },
        no: {
          text: 'No',
          value: 'no',
        },
      },
    }).then((value) => {
      if (value === 'yes') {
        this.setState({ row_updating: true });
        const response = deleteEnrolledUser(id);
        if (response?.success) {
          swal(i18n.t('success'), 'User enrollment deleted.', 'success', {
            buttons: false,
            timer: 2000,
          });
          this.loadAllEnrolledUsers(this.state.query);
          this.setState({ row_updating: false });
        } else {
          this.setState({ row_updating: false });
        }
      }
      return false;
    });
  }

  async deleteSelected() {
    let { selected_ids } = this.state;
    if (!selected_ids.length) {
      swal('Error', 'Please select any id', 'error');
      return;
    }
    swal('Are you sure.? Do you want to delete selected enrollments.?', {
      buttons: {
        yes: {
          text: 'Yes',
          value: 'yes',
        },
        no: {
          text: 'No',
          value: 'no',
        },
      },
    }).then(async (value) => {
      if (value === 'no') {
        return;
      }
      this.setState({ row_updating: true });
      let payload = {
        ids: selected_ids,
      };
      const response = await enrollBulkDelete(payload);
      if (response?.success) {
        swal(i18n.t('success'), 'Selected enrollments deleted.', 'success', {
          buttons: false,
          timer: 2000,
        });
        this.loadAllEnrolledUsers(this.state.query);
        this.setState({ row_updating: false });
      } else {
        this.setState({ row_updating: false });
      }

      return false;
    });
  }

  async approveRejectSelected(is_approve) {
    let { selected_ids } = this.state;
    if (!selected_ids.length) {
      swal('Error', 'Please select any id', 'error');
      return;
    }
    let msg = is_approve
      ? 'Are you sure.? Do you want to approve selected enrollments.?'
      : 'Are you sure.? Do you want to reject selected enrollments.?';
    let msg_2 = is_approve ? 'Selected enrollments approved.' : 'Selected enrollments rejected.';
    swal(msg, {
      buttons: {
        yes: {
          text: 'Yes',
          value: 'yes',
        },
        no: {
          text: 'No',
          value: 'no',
        },
      },
    }).then(async (value) => {
      if (value === 'no') {
        return;
      }
      this.setState({ row_updating: true, bulk_updating: true });
      let payload = {
        ids: selected_ids,
        is_approve: is_approve,
      };
      const response = await approveOrRejectEnrolls(payload);
      if (response?.success) {
        swal(i18n.t('success'), msg_2, 'success', {
          buttons: false,
          timer: 2000,
        });
        this.loadAllEnrolledUsers(this.state.query);
        this.setState({ row_updating: false, bulk_updating: false });
      } else {
        this.setState({ row_updating: false, bulk_updating: false });
      }
      return false;
    });
  }

  render() {
    let { customers, auctions, input, selected_ids, clients } = this.state;
    let queryString = new URLSearchParams(input).toString();
    // Belt-and-suspenders: guarantee DataTable never receives a non-array
    // or null-containing list, no matter what state mutation happened.
    const safeAuctions = Array.isArray(auctions) ? auctions.filter((row) => row != null) : [];

    return (
      <React.Fragment>
        <HeaderBanner title={i18n.t('enrolled_users')} />

        <section className="sptb mt-5">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card mb-0">
                  <div className="card-header d-flex justify-content-between">
                    <div className="d-flex justify-content-between pe-1"></div>
                    <div className="">
                      <div className="" style={{ width: '250px' }}>
                        <select
                          className="form-select textbox fs15 text-gray filter-icon rounded-2"
                          data-placeholder="Select Client"
                          name="client"
                          value={this.state.input.client}
                          onChange={this.handleChange}
                        >
                          <option value="">{i18n.t('select_client')}</option>
                          {clients.length > 0 &&
                            clients.map((item) => {
                              return (
                                <option value={item.id} key={item.id}>
                                  {item.organization_name}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-3 col-md-3">
                        <div className="form-group">
                          <label className="form-label">{i18n.t('username')}</label>
                          <Select
                            className="rounded-5 "
                            placeholder={i18n.t('bidder')}
                            options={customers}
                            onChange={(e) => {
                              let { input } = this.state;
                              input.user_id = e.value;
                              this.setState({ input });
                            }}
                            name="user_id"
                            styles={selectStyles}
                            menuPlacement="auto"
                            menuPortalTarget={document.body}
                          ></Select>
                        </div>
                      </div>
                      <div className="col-sm-2 col-md-2">
                        <div className="form-group">
                          <label className="form-label">
                            {i18n.t('auction')} {i18n.t('status')}
                          </label>
                          <select
                            className="form-control"
                            name="auc_status"
                            value={this.state.input.pay_type}
                            onChange={this.handleChange}
                          >
                            <option value="">
                              --{i18n.t('auction')} {i18n.t('status')}--
                            </option>
                            <option value="active">{i18n.t('active')}</option>
                            <option value="upcoming">{i18n.t('upcoming')}</option>
                            <option value="previous">{i18n.t('previous')}</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-3 col-md-3">
                        <div className="form-group">
                          <label className="form-label">{i18n.t('pay_type')}</label>
                          <select
                            className="form-control"
                            data-placeholder={i18n.t('pay_type')}
                            name="pay_type"
                            value={this.state.input.pay_type}
                            onChange={this.handleChange}
                          >
                            <option value="">--{i18n.t('pay_type')}--</option>
                            <option value="online">{i18n.t('online')}</option>
                            <option value="offline">{i18n.t('offline')}</option>
                            <option value="wallet">{i18n.t('wallet')}</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-2 col-md-2">
                        <div className="form-group">
                          <label className="form-label">{i18n.t('status')}</label>
                          <select
                            className="form-control"
                            data-placeholder={i18n.t('pay_type')}
                            name="status"
                            value={this.state.input.status}
                            onChange={this.handleChange}
                          >
                            <option value="">--{i18n.t('status')}--</option>
                            <option value="A">{i18n.t('approved')}</option>
                            <option value="N">{i18n.t('not_approved')}</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-2 col-md-2">
                        <div className="form-group mt-4 mb-0">
                          <button
                            type="button"
                            className="btn btn-primary rounded-pill mt-2"
                            onClick={() => {
                              if (input.group_id) {
                                input.group = input.group_id;
                              }
                              this.setState({ selected_ids: [] });
                              let qstring = new URLSearchParams(input).toString();

                              this.loadAllEnrolledUsers(qstring);
                            }}
                          >
                            <i className="fa fa-search" />
                            &nbsp;
                            {i18n.t('search')}
                          </button>
                        </div>
                      </div>
                    </div>

                    {!this.state.is_loading && safeAuctions.length === 0 && (
                      <div className="text-danger text-center p-3 border border-danger">
                        {i18n.t('no_data_found')}
                      </div>
                    )}

                    <div className="table-responsive ">
                      {this.state.is_loading && <ListTable />}
                      {!this.state.is_loading && safeAuctions.length > 0 && (
                        <div className="table-wrapper">
                          <div className="d-flex justify-content-between my-1">
                            {(user.role === 'A' || user.role === 'F') && (
                              <div>
                                {user.role === 'A' && (
                                  <button
                                    className="btn btn-sm btn-outline-danger rounded-0"
                                    disabled={selected_ids.length < 1}
                                    onClick={() => {
                                      this.deleteSelected();
                                    }}
                                  >
                                    <i className="fa fa-trash" />
                                    &nbsp;{i18n.t('delete')}
                                  </button>
                                )}
                                <button
                                  className="btn btn-sm btn-outline-success rounded-0"
                                  disabled={selected_ids.length < 1}
                                  onClick={() => {
                                    this.approveRejectSelected(true);
                                  }}
                                >
                                  {this.state.bulk_updating ? (
                                    <span
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                  ) : (
                                    <i className="fa fa-check" />
                                  )}
                                  &nbsp;{i18n.t('approve')}
                                </button>
                                <button
                                  className="btn btn-sm btn-outline-warning rounded-0"
                                  disabled={selected_ids.length < 1}
                                  onClick={() => {
                                    this.approveRejectSelected(false);
                                  }}
                                >
                                  <i className="fa fa-ban" />
                                  &nbsp;{i18n.t('reject')}
                                </button>
                              </div>
                            )}

                            {this.state.input.group && safeAuctions.length > 0 && (
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-info rounded-0"
                                onClick={this.activateAllUserEnroll}
                              >
                                Activate all enrolls in this group
                              </button>
                            )}
                            <a
                              className="btn btn-outline-danger btn-lg rounded-0"
                              href={
                                apiUrl + `enrolled_users/excel?l_user=${user.id}&${queryString}`
                              }
                              target="_new"
                            >
                              <span className="text-danger">
                                <i className="fa fa-file-excel-o fa-2x" />
                              </span>
                            </a>
                          </div>
                          <DataTable
                            title=""
                            fixedHeader
                            columns={this.state.columns}
                            data={safeAuctions}
                            customStyles={customStyles}
                            highlightOnHover
                            pagination
                            paginationServer
                            paginationTotalRows={this.state.totalRows}
                            paginationPerPage={this.state.input.limit}
                            paginationDefaultPage={this.state.currentPage}
                            paginationRowsPerPageOptions={[15, 25, 50, 100]}
                            onChangeRowsPerPage={(size) => {
                              this.setState({ rows_per_page: 15 });
                              let { input } = this.state;
                              input.limit = size;
                              this.setState({ input });
                              this.handlePageChange(1);
                            }}
                            paginationComponentOptions={{
                              rowsPerPageText: 'Enrolls per page:',
                              rangeSeparatorText: i18n.t('out'),
                            }}
                            onChangePage={this.handlePageChange}
                            selectableRows={user.role === 'A' || user.role === 'F'}
                            selectableRowDisabled={(row) => !row || row.status === 'A'}
                            onSelectedRowsChange={(e) => {
                              let { selectedRows } = e;
                              const selectedIds = selectedRows
                                .filter((row) => row != null)
                                .map((row) => row.id);
                              this.setState({ selected_ids: selectedIds });
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}